export class AirportMaintenanceSaveBean {
  seqNo: number;
  airportCode: string | null;
  airportName: string | null;
  locatedCityName: string | null;
  locatedCitySeqNo: number | null;
  isActivated: number | null;
  createUser: string | null;
  createDt: Date | null;
  updateUser: string | null;
  updateDt: Date | null;

  constructor() {
    this.seqNo = -1;
    this.airportCode = null;
    this.airportName = null;
    this.locatedCityName = null;
    this.locatedCitySeqNo = null;
    this.isActivated = null;
    this.createUser = null;
    this.createDt = null;
    this.updateUser = null;
    this.updateDt = null;
  }
}
